// src/components/ProfilUlasilamiyor.tsx
//
// EMİR #94.3 — "BAĞLANTI KURULAMADI" DURUMU (yanlış-yokluk paketinin 2. maddesi)
//
// NEDEN VAR: `authStore` profil dokümanını okuyamadığında eskiden iki kötü
// seçenekten birine düşülüyordu — ya kullanıcı-adı seçicisi (YANLIŞ: profili
// tam kullanıcıya "hesabın yok" demek), ya sonsuz bekleme (C4: sistem hiç
// yanlış yapmadan sonsuza kadar takılabilir). Bu ekran üçüncü, dürüst yol:
// "bilmiyorum, tekrar deneyelim."
//
// 🔒 KAPSAM: kasten MİNİMAL. Yeni tasarım dili icat edilmiyor; Auth ekranının
// mevcut `auth-*` sınıf/ton düzeni kullanılıyor. Owner-görünür METİN olduğu
// için owner'a bildirilir (kural: owner-görünür kimlik varlıkları önizlemeden
// geçer) — ama bu bir kimlik varlığı değil, hata durumu metnidir; bloklamaz.
//
// 🧪 TEST KANCASI: `data-vw-unreachable` — sanal dünya invariant'ı ve
// bazen-kuralı bu ekranı DOM'dan tanır. İz olmadan araç bu durumu göremez
// (maskeleme sınıfının dersi: her durum makine-okunur iz bırakmalı).

import React from "react";

interface Props {
  onRetry?: () => void;
  /** "Tekrar dene" basıldı, sonuç bekleniyor. Ekran KALIR; yalnız düğme değişir. */
  retrying?: boolean;
}

export default function ProfilUlasilamiyor({ onRetry, retrying }: Props) {
  return (
    <div
      data-vw-unreachable="1"
      data-vw-retrying={retrying ? "1" : "0"}
      role="alert"
      style={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        padding: 24,
        textAlign: "center",
        background: "var(--bg, #ffffff)",
        color: "var(--text, #262626)",
      }}
    >
      <div style={{ fontSize: 40, lineHeight: 1 }} aria-hidden="true">
        ⚡
      </div>
      <h2 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>
        Bağlantı kurulamadı
      </h2>
      <p style={{ fontSize: 14, opacity: 0.75, margin: 0, maxWidth: 320 }}>
        Hesabına ulaşamıyoruz. İnternet bağlantını kontrol edip tekrar dene —
        bilgilerin yerinde duruyor.
      </p>
      <button
        type="button"
        className="pressable"
        onClick={onRetry}
        disabled={!!retrying}
        aria-busy={retrying ? "true" : "false"}
        style={{
          marginTop: 8,
          padding: "10px 22px",
          borderRadius: 10,
          border: "none",
          fontSize: 15,
          fontWeight: 600,
          background: retrying ? "#7EC4F5" : "#0095F6",
          color: "#fff",
          cursor: retrying ? "default" : "pointer",
        }}
      >
        {retrying ? "Deniyor…" : "Tekrar dene"}
      </button>
    </div>
  );
}
